<template>
  <transition name="el-fade-in-linear">
  <div class="alarmTip-div " v-show="dialogFormVisible">
    <div slot="title" class="header-title">
      <img :src="require('@/assets/icon-test.png')" />
      <div>告警提醒</div>
    </div>
    <div class="content">
      <div v-if="this.data.protocolType==2">
        电&ensp;池&ensp;I&ensp;D&ensp;:
        <span>{{data.devId}}</span>
      </div>
      <div v-if="this.data.protocolType==1 || this.data.protocolType==3 || this.data.protocolType==4">
        设 备 编 号:
        <span>{{data.devId}}</span>
      </div>
      <div v-if="this.data.protocolType==2"> 
        告 警 类 型 :
        <span>{{data.type}}</span>
      </div>
      <div>
        告 警 名 称 :
        <span>{{data.name}}</span>
      </div>
      <div>
        告 警 时 间 :
        <span>{{data.time}}</span>
      </div>
    </div>
    <div class="alarm-footer">
      <el-button type="warning" @click="handleClose()" class="alarm-btn" style="padding:8px 30px">忽 略</el-button>
      <el-button type="warning" @click="handleList()" class="alarm-btn">查看详情</el-button>
    </div>
  </div>
  </transition>
</template>
<script>
import {EventBus} from '@/utils/event-bus'
export default {
  data() {
    return {
      dialogFormVisible: false,
        showOpacity:false,
        data:{}
    };
  },


  created() {
  },
  methods: {
    openModel(item) {
      this.dialogFormVisible = true;
      this.showOpacity=false;
      this.data=item
      
      // console.log(item);
      this.$nextTick(()=>{
          this.showOpacity=true;
      })
    },
      hideModel(item) {
          this.dialogFormVisible = false;

      },
    // 忽略
    handleClose() {
      this.dialogFormVisible = false;
    },
    // 查看详情
    async   handleList(){
      if(this.data.protocolType==1){
     
        if (this.$route.path != '/monitoring/unusual'){
             sessionStorage.setItem("codeId",this.data.devId);
        await  this.$router.push({
           path: "/monitoring/unusual"
          });
        }
        EventBus.$emit("AlarmCode",this.data.devId)
        
      }
      if(this.data.protocolType==3){
     
        if (this.$route.path != '/monitoring/batteryAbnormalAlarm'){
              sessionStorage.setItem("codeId",this.data.devId);
        await  this.$router.push({
            path: "/monitoring/batteryAbnormalAlarm"
          });
        }
        EventBus.$emit("AlarmCode",this.data.devId)
      
      }
    if(this.data.protocolType==4){
      
      if (this.$route.path != '/monitoring/uDanDeviceController'){
          sessionStorage.setItem("codeId",this.data.devId);
      await  this.$router.push({
        path: "/monitoring/uDanDeviceController"
        });
      }
      EventBus.$emit("AlarmCode",this.data.devId)
      
    }
      if(this.data.protocolType==2){
        // console.log(this.$route.path);
        // debugger
        
          
        if (this.$route.path != '/monitoring/towerAlarm'){
           sessionStorage.setItem("batteryId",this.data.devId);
         await this.$router.push({
            path: "/monitoring/towerAlarm",
          
          });
         
        }
         EventBus.$emit("AlarmDetail",this.data.devId) // 通过事件发送消息通知告警页面; EventBus.$emit("消息名称", '发送的的消息');
      }
    }
  }
};
</script>
<style scoped lang='scss'>
.alarmTip-div {
  position: absolute;

  right: 10px;
  bottom: 10px;
  margin: 0;
  z-index: 2000;
  background: rgba(250, 250, 250, 1);
  border: 1px solid rgba(219, 4, 4, 1);
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
  border-radius: 10px;
  .header-title {
    padding: 10px 21px 5px;
    overflow: hidden;
    img {
      display: block;
      float: left;
      margin-left: 0px;
    }
    div {
      float: left;
      margin-left: 10px;
      color: #db0404 !important;
      font-size: 18px !important;
      height: 30px;
      line-height: 45px;
    }
  }
  .content {
    padding: 5px 10px 10px 20px;
    div {
      font-size: 14px;
      font-family: PingFang HK;
      font-weight: 400;
      line-height: 28px;
      color: rgba(51, 51, 51, 1);
    }
  }
  .alarm-footer {
    text-align: center;
    padding-bottom: 15px;
    .alarm-btn {
      border: 1px solid rgba(219, 4, 4, 1);
      box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
      border-radius: 26px;
      font-size: 14px;
      text-align: center;
      cursor: pointer;
      background: rgba(255, 0, 0, 0.1);
      border: 1px solid rgba(255, 0, 0, 1);
      color: rgba(255, 0, 0, 1);
      padding: 8px 20px;
      &:hover {
        background: rgba(255, 0, 0, 1);
        color: rgba(255, 255, 255, 1);
      }
    }
  }
}

  .alarmTip-opacity{
    opacity: 1;
  }
</style>



// WEBPACK FOOTER //
// src/components/Alarmtips/index.vue